import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ContentElement, VisibilityEnum } from '../../models/sections-model';

@Component({
  selector: 'kw-title-renderer',
  templateUrl: './title-renderer.component.html',
  styleUrls: ['./title-renderer.component.scss']
})
export class TitleRendererComponent implements OnInit,OnChanges {
  @Input() title:ContentElement;
  @Input() preview:boolean;
  classes:string[];
  previewEl:HTMLElement;
  displayEl:HTMLElement;
  inputEl:HTMLElement;
  visibilityClass:string;

  @ViewChild('hoverContentEl',{read:ElementRef}) hoverContentEl:ElementRef;
  @Output() updatedContent:EventEmitter<ContentElement> = new EventEmitter<ContentElement>()
  
  constructor() { }

  ngOnInit(): void {
    console.log(this.preview)
  }

  ngOnChanges(changes:SimpleChanges):void{
    if(changes["title"]){
      console.log(changes["title"]);
      if(this.title && this.title.classes){
        this.classes = this.title.classes?this.title.classes:[];
      }
      if(this.title && this.title.visibility){
        //this.visibilityClass = this.title.visibility.toString().toLowerCase();
        this.title = this.cleanupClasses(this.title);
        console.log(this.title.visibility)
        switch (this.title.visibility) {
          case VisibilityEnum.HIDDEN:
            this.classes.push('hidden-all');
            this.visibilityClass = 'hidden-all';            
            break;
          case VisibilityEnum.VISIBLE:
            this.classes.push('shown-all');  
            this.visibilityClass = 'shown-all'; 
            break;
          case VisibilityEnum.HIDDEN_ON_MOBILE:
            this.classes.push('hide-mobile'); 
            this.visibilityClass = 'hide-mobile';
            break;
          default:
            this.classes.push('shown-all');
            this.visibilityClass = 'shown-all';
            break;
        }
      }else{
        this.classes.push('shown-all');
      }
      
    }
  }
  onMouseEnter(hoverContentEl:HTMLElement){
    if(this.preview){
      console.log("hovering");
      this.previewEl = hoverContentEl.querySelector('.preview-selected');
      this.displayEl = hoverContentEl.querySelector(".content-element");
      //this.inputEl = hoverContentEl.querySelector("input");
      console.log(this.previewEl)
      if(this.previewEl && this.previewEl.classList.contains('hide')){
        this.previewEl.classList.toggle('hide');
        this.previewEl.classList.toggle('show');
      }
    }
  }
  onClick(hoverContentEl:HTMLElement){
    console.log(hoverContentEl);
    if(this.preview) {
      this.displayEl = hoverContentEl.querySelector(".content-element");
      if(this.displayEl) {
        this.displayEl.focus();
        // Optional: Select all text for better UX
        this.selectAllText(this.displayEl);
      }
    }
  }
  private selectAllText(element: HTMLElement) {
    const range = document.createRange();
    range.selectNodeContents(element);
    const selection = window.getSelection();
    selection?.removeAllRanges();
    selection?.addRange(range);
  }
  onBlur(e: FocusEvent) {
    if(this.preview) {
      const target = e.target as HTMLElement;
      console.log(target.innerText);
      this.title.text = target.innerText.trim();
      this.updatedContent.emit(this.title);

      if(this.previewEl && this.previewEl.classList.contains('show')) {
        this.previewEl.classList.toggle("show");
        this.previewEl.classList.toggle("hide");
      }
    }
  }
  /* onBlur(e){
    if(this.preview){
      console.log(this.displayEl.innerText);
      this.title.text = this.displayEl.innerText;
      this.updatedContent.emit(this.title);
    }
  } */
  onMouseOut(hoverContentEl:HTMLElement){

  }

  cleanupClasses(title:ContentElement):ContentElement{
    let candidateClasses = ['hidden-all','hide-mobile','shown-all'];
    candidateClasses.forEach(candidateClass => {
      if(title.classes && title.classes.includes(candidateClass)){
        let itmIndx = title.classes.indexOf(candidateClass);
        if(itmIndx !== -1){
          console.log("Removing classes")
          title.classes.splice(itmIndx,1);
        }
      }
    })
    return title
  }

  onEnterKey(e: KeyboardEvent) {
    if(this.preview) {
      e.preventDefault(); // Prevent line breaks
      (e.target as HTMLElement).blur(); // Trigger save on Enter
    }
  }
  

}
